import { Anchor, Card } from '@zenid/web';
import { css } from '../../../../styled-system/css';
import { flex } from '../../../../styled-system/patterns';

/** FIXME: デザイナーに画面確認 */
export function IntegrationComplete() {
  return (
    <Card
      className={css({
        width: '343px',
        backgroundColor: '{colors.background.white}',
        padding: '{spacing.40} {spacing.20}',
        sm: { width: '400px', padding: '{spacing.40}' },
      })}
    >
      <div
        className={flex({
          flexDirection: 'column',
          justifyContent: 'center',
        })}
      >
        <div className={flex({ justifyContent: 'center', paddingBottom: '{spacing.24}' })}>
          <img
            width="88px"
            src={`${import.meta.env.VITE_ASSETS_URL}/assets/images/change_success.png`}
            alt="アカウント連携成功"
          />
        </div>
        <div
          className={flex({
            flexDirection: 'column',
            gap: '{spacing.16}',
          })}
        >
          <h1
            className={css({
              textStyle: 'headding.l',
              textAlign: 'center',
              color: '{colors.text.main}',
              wordBreak: 'keep-all',
            })}
          >
            サブメールアドレスの追加が完了しました
          </h1>
        </div>
      </div>
      <Anchor
        variant="button"
        href="/home"
        className={css({ marginTop: '{spacing.24}' })}
        color="primary"
        size="l"
        stretch="container"
      >
        戻る
      </Anchor>
    </Card>
  );
}
